import React from "react"

export default function TypeConditionalText({ value, description }) {
  return (
    <div>
      <label>{description} </label>
      {value}{" "}
    </div>
  )
}
